export const TALK_TO_SALES_CALENDLY_URL =
  'https://calendly.com/d/cwg5-pjb-87w/30min?embed_type=Inline&hide_event_type_details=1&hide_gdpr_banner=1&primary_color=234542';

export interface TalkToSalesAgendaItem {
  icon: string;
  text: string;
}

export interface TalkToSalesTrustStat {
  value: string;
  label: string;
}

export interface TalkToSalesChecklistItem {
  title: string;
  subtitle?: string;
}

export const TALK_TO_SALES_AGENDA: TalkToSalesAgendaItem[] = [
  { icon: '◎', text: 'Size your report volume' },
  { icon: '⚡', text: 'Live demo of all 4 providers' },
  { icon: '$', text: 'Custom pricing & SLA quote' },
];

export const TALK_TO_SALES_STATS: TalkToSalesTrustStat[] = [
  { value: '200+', label: 'CLIENTS' },
  { value: '12M+', label: 'REPORTS' },
  { value: '<30 min', label: 'RESPONSE' },
];
